module.exports = __webpack_public_path__ + "fda35d4c52d7f1868969f14044aecd27.pdf";